import gql from "graphql-tag";

export const SEND_PASSWORD_RESET_MAIL = gql`
    mutation SendPasswordResetMail($email: String!, $callbackPath: String!) {
        sendPasswordResetMail (input: {
            email: $email,
            callbackPath: $callbackPath
        }){
            user{
                id
            }
        }
    }
`;
